export default {"src":"/_next/static/media/1.3-h.58fa9c7a.svg","height":22,"width":18,"blurWidth":0,"blurHeight":0};